import { injectable } from 'inversify';

import { FormatService } from '@vk-hr-tek/core/format';

import { DateRange } from '@app/gen/settings';

@injectable()
export class SettingsSubstitutesMapper {
  constructor(private format: FormatService) {}

  processSubstituteDates(dates?: DateRange[]) {
    if (!dates?.length) {
      return 'Постоянный';
    }

    const substituteDatesLabel =
      this.format.toDateRangeWithDaysBetweenInclusive(
        dates[0].from_date,
        dates[0].to_date,
      );

    if (dates.length > 1) {
      return `${substituteDatesLabel} и еще ${dates.length - 1}`;
    }

    return substituteDatesLabel;
  }
}
